export default __webpack_public_path__ + "static/media/home_icon_active.64e660fc.svg";